module.exports = __webpack_public_path__ + "static/media/klickexcardnz.132336f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/klickexcardnz.png
// module id = 5976
// module chunks = 1